import fuse from '../../../_libs/redux-fusion';
import {TimerExportComponent} from './TimerExportComponent';
import {timerExportActions} from '../../actions/timerExportActions';

const StreamedComponent = (state$, dispatch) => (props$) => {
  const onUpdateFilterData = payload => dispatch(timerExportActions.applyFilter(payload));

  return props$
    .map(props => ({
      ...props,
      onUpdateFilterData,
    }));
};

export const TimerExportContainer = fuse(StreamedComponent)(TimerExportComponent);



// WEBPACK FOOTER //
// ./src/js/timers/components/TimerExport/TimerExportContainer.js